/*******************************************************************************
 * Copyright (c) 2023 Belltane
 *
 * All rights reserved.
 *
 * Contributors:
 *   
 *  Amina Rais - Initial implementation
 *  Version: 1.0.0
 *
 *******************************************************************************/
import { appReducer } from './reducers';
import { configureStore } from '@reduxjs/toolkit';
import logger from 'redux-logger';



const store = configureStore({
  reducer: appReducer,
  devTools: process.env.REACT_APP_NODE_ENV_VAR === "DEV",
  middleware: (getDefaultMiddleware) =>
    process.env.REACT_APP_NODE_ENV_VAR === "DEV"
      ? getDefaultMiddleware().concat(logger)
      : getDefaultMiddleware(),
});

export default store;